export default {
  LOADER_VERSION: '5.5.5',
  EVENTS: {
    ERROR_LOADING_WIDGET: 'errorLoadingWidget',
    REFRESH_WIDGET: 'refreshWidget',
  }
}